import React from "react";
import { MaintainanceRequestDetailsScreenContainer } from "src/containers";

export const MaintainanceRequestDetailsScreen = () => {
  return <MaintainanceRequestDetailsScreenContainer />;
};
